module.exports = {
	"application_form.entripName": "Наименование субъекта предпринимательства",
	"application_form.invalid_type_id": "Инвалидность",
	"application_form.formError": "Не удалось пользоваться услугой. Пожалуйста, попробуйте позже.",
	"application_form.phoneError": "Введите правильный номер телефона.",
	"application_form.phoneLabel": "Телефон (+998xxxxxxxxx)",
	"application_form.agreementHint": "Ознакомлен <a href={link} id={id} data-toggle={dataToggle} data-target={dataTarget}>об ответственности</a>",
	"application_form.answerOnlyElectron": "Я согласен, что на заявку ответят только в электронном виде",
	"application_form.answerElectronAndWritten": "Я согласен получить ответ на свое заявление в бумажном и электронном виде",
	"application_form.yearError": "Введите правильную дату рождения: (dd.mm.19xx/20xx)",
	"application_form.emailError": "Тўғри электрон почта манзилини кўрсатинг",
	"application_form.surname": "Фамилия",
	"application_form.name": "Имя",
	"application_form.secondName": "Отчество",
	"application_form.fileError": "Запрещается загружать файлы размером более 5 мб!",
	"application_form.fileError2": "Запрещается загружать файлы такого формата!",
	"application_form.captchaError": "Неправильный ответ. Попробуйте еще раз.",
	"application_form.captchaHint": "Введите числа на рисунки",
	"application_form.region": "Регион",
	"application_form.district": "Район (город)",
	"application_form.country": "Государство",
	"application_form.gender": "Пол",
	"application_form.birthdate": "Дата рождения",
	"application_form.isSecret": "Открытость обращения",
	"application_form.address": "Адрес",
	"application_form.email": "Электронная почта",
	"application_form.feedback_email": "Электронная почта (необязательно)",
	"application_form.phone": "Телефон",
	"application_form.entrip": "Предприниматель",
	"application_form.entripHint": "Представиться как субъект предпринимательства, если Вы действительно отправляете обращение в качестве субъекта предпринимательства.",
	"application_form.status": "Статус",
	"application_form.fileLabel": "Дополнительный файл",
	"application_form.fileHint": "Выберите допольнительный файл <br/>(размер до 5мб)",
	"application_form.applicationLabel": "Текст обращения",
	"application_form.applicationHint": "Мурожаатингиз тезкор равишда ҳал этилишини истасангиз, ҳар бир масала бўйича алоҳида мурожаат йўллашингизни ҳамда мазкур мурожаатни лўнда, оддий ва равон тилда баён этишингизни сўраймиз!",
	"application_form.sendButton": "Отправить",
	"application_form.notAccepted": "Запрещенный файл",
	"application_form.maxNumberOverflow": "Запрещается загружать более 10 файлов",
	"application_form.uploadFile": "Загрузить файл",
	"application_form.phoneReal": "Номер телефона подтвержден!",
	"application_form.getCode": "Получить код",
	"application_form.enterCode": "Введите код проверки",
	"application_form.resendCode": "Заново отправить",
	"application_form.codeSendTo": "Код проверки был отправлен на номер",
	"application_form.fileSize": "Размер одного файла не должен превышать 10 Мб., в количестве не более 10 файлов",
	"application_form.fileUploaded": "Файл загружен",
	"application_form.error": "Ошибка!",
	"application_form.secretInfo": "Открытость информации об обращении и заявителе",
	"application_form.makhalla": "Махалля",
	"application_form.man": "Мужчина",
	"application_form.woman": "Женщина",
	"application_form.yes": "Да",
	"application_form.no": "Нет",
	"application_form.showPhone": "Для отправки обращения укажите номер телефона.",
	"application_form.unknownError": "Произошла ошибка!",
	"application_form.applicationSuccess": "Ваше обращение было успешно отправлено в {title}!",
	"application_form.applicationAlreadySuccess": "Ваш запрос уже был отправлен. Дождитесь ответа на отправленный запрос!",
	"application_form.pleaseSave": "Внимание!!! Сохраните следующее данные",
	"application_form.applicationNo": "Номер обращения",
	"application_form.applicationToken": "Код обращения",
	"application_form.authority": "Наименование организации",
	"application_form.request_no": "Номер обращения",
	"application_form.note_title": "Просим ввести данные, удостоверяющие Вашу личность",
	"application_form.note_warning": "Введенная персональная информация не будет разглашена и распространена третьим лицам!",
	"application_form.note_text": "Введение данных, удостоверяющих личность предоставляет следующие удобства:",
	"application_form.note_list_item_one": "часть формы отправки обращения будет заполнена автоматически",
	"application_form.note_list_item_two": "отправленное обращение будет сохранено на Ваше имя и будет доступно в любое время при входе в систему через сервис id.egov.uz",
	"application_form.note_list_item_three": "предотвращаются случаи необоснованного оставления обращения без рассмотрения",
	"application_form.preliminary_form_title": "ДАННЫЕ ДОКУМЕНТА, УДОСТОВЕРЯЮЩЕГО ЛИЧНОСТЬ*:",
	"application_form.passport_series": "Серия",
	"application_form.passport_number": "Номер",
	"application_form.passport_helper_text": "*В качестве документа, удостоверяющего личность можно использовать: паспорт гражданина, ID-карту и загранпаспорт гражданина.",
	"application_form.dd_mm_yy": "день | месяц | год",
	"application_form.captcha_label": "Введите число из картинки",
	"application_form.preliminary_form_link": "Пропустить этот шаг",
	"application_form.captcha": "Введите ответ примера на картинке",
	"application_form.close": "Назад",
	"application_form.full_name": "Ф.И.О",
	"application_form.feedback_label": "Не нашли свою махаллю?",
	"application_form.choose_mahalla": "Выберите свою махаллю...",
	"application_form.feedback_title": "Обратная связь",
	"application_form.feedback_alert": "Ваше сообщение успешно отправлено !",
	"application_form.needed_field": "Необходимо заполнить поле: {attribute}",
	"application_form.is_agree": "Ознакомлен с отвественностью",
	"application_form.juridical_tin": "ИНН",
	"application_form.get_tin": "Получить данные по ИНН",
	"application_form.check_tin": "Проверка ИНН",
	"application_form.passport": "Паспорт, ID-карта или загранпаспорт гражданина",
	"application_form.cert_helper_text": "Укажите серию и номер свидетельства о рождении",
	"application_form.birth_certificate": "Свидетельство о рождении",
	"application_form.tin_confirmed": "Действительность ИНН подтверждена",
	"application_form.tin_rejected": "ИНН не действителен",
	"apps.appeals.appTitle": "Способы отправления обращений",
	"apps.appeals.goToRecept": "Посетите Народную приемную Республики Узбекистан по месту жительства",
	"apps.appeals.callCenter": "Звоните на телефонный номер<br><span>1000</span> или <span>0-800-210-00-00</span><br>и изложите суть Вашего обращения",
	"apps.appeals.sendAppeal": "Отправьте обращение в виртуальную приемную",
	"apps.Authorities.showAll": "Все направления",
	"apps.Authorities.close": "Назад",
	"apps.Authorities.step": "Раздел",
	"apps.Authorities.noData": "Информация не найдена",
	"apps.Authorities.searchBtn": "Поиск",
	"apps.Authorities.emailShort": "эл. почта",
	"apps.Authorities.phone": "Телефон",
	"apps.Authorities.phoneShort": "тел.",
	"apps.Authorities.website": "Веб-сайт",
	"apps.Authorities.websiteShort": "веб-сайт",
	"apps.Authorities.fax": "Факс",
	"apps.Authorities.faxShort": "факс",
	"apps.Authorities.formLabel": "Отправить обращение",
	"apps.Authorities.appTitle": "Отправка обращений и приемные дни министерств и ведомств",
	"apps.Authorities.firstUsellessBtn": "План приема граждан",
	"apps.Authorities.secondUselessBtn": "Отправка обращений государственным органам",
	"apps.Authorities.opt": "Нет",
	"apps.Authorities.formInfo": "Отправка обращений в виртуальную приемную организации",
	"apps.Authorities.fio": "Ф.И.О.",
	"apps.Authorities.position": "Должность",
	"apps.Authorities.receptDays": "График приема",
	"apps.Authorities.orgAdress": "Почтовый адрес организации",
	"apps.Authorities.phone2": "Номер телефона организации",
	"apps.Authorities.email2": "Электронная почта",
	"apps.Authorities.days": "Дни недели",
	"apps.Authorities.time": "Время",
	"apps.Authorities.authFirstTab": "Приемные дни и адрес",
	"apps.Authorities.authSecondTab": "Функции и задачи",
	"apps.Authorities.authThirdTab": "Отправка обращений",
	"apps.Authorities.functions": "Основные функции",
	"apps.Authorities.tasks": "Задачи",
	"apps.Authorities.error": "Ошибка!",
	"apps.Authorities.printButton": "Печать",
	"apps.Authorities.unknownError": "Произошла ошибка!",
	"apps.consulates.appName": "Консульские учреждение Узбекистана за рубежом",
	"apps.consulates.aLabel": "Консульские учреждение Узбекистана за рубежом",
	"apps.consulates.bLabel": "Форма отправки обращений для граждан за рубежом",
	"apps.harassment-message.attentionTitle": "Внимание!",
	"apps.harassment-message.attentionText": "Если Вы после обращения подверглись преследованию, немедленно сообщите об этом",
	"apps.harassment-message.attentionBtn": "Сообщение о преследовании",
	"apps.Qa.showAll": "Все направления",
	"apps.Qa.appTitle": "Получайте ответы на интересующие вас вопросы",
	"apps.Qa.close": "Назад",
	"apps.Qa.step": "Раздел",
	"apps.Qa.noData": "Информация не найдена",
	"apps.Qa.searchBtn": "Поиск",
	"apps.Qa.qaHint": "Если вы не удовлетворены ответом, можете обратиться в следующее организации:",
	"apps.Qa.watched": "Просмотров",
	"apps.Receptions.showAll": "Все направления",
	"apps.Receptions.uzbekistan": "Республика Узбекистан",
	"apps.Receptions.close": "Назад",
	"apps.Receptions.step": "Раздел",
	"apps.Receptions.noData": "Информация не найдена",
	"apps.Receptions.searchBtn": "Поиск",
	"apps.Receptions.address": "Адрес",
	"apps.Receptions.email": "Электрон почта",
	"apps.Receptions.phone": "Телефон",
	"apps.Receptions.website": "Веб-сайт",
	"apps.Receptions.fax": "Факс",
	"apps.Receptions.appTitle": "Адреса народных приемных",
	"apps.Receptions.recpCount": "Количество приемных",
	"apps.Receptions.trsPhone": "Телефоны доверия",
	"apps.Receptions.contacts": "Контакты",
	"apps.Receptions.appeal": "Обращение",
	"apps.Receptions.more": "Батафсил",
	"apps.Receptions.onMap": "На карте",
	"apps.step": "Раздел",
	"apps.mainFormTitle": "Виртуальную Приемную Президента Республики Узбекистан",
	"fileSizeValidation": "Файл «{file_name}» превышает допустимый размер. Загружаемый файл не должен превышать 10 Мб"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/ru.json
// module id = 929
// module chunks = 0